import { THttpService } from '@/services/HttpService';

import {
  TListPurchaseOptions,
  TResponseListPurchaseOptionsData,
} from './types';

const formatSuccess = (
  data: TResponseListPurchaseOptionsData,
): TListPurchaseOptions => {
  const formatedResponse: TListPurchaseOptions = {
    ...data,
  };
  return formatedResponse;
};

export const listPurchaseOptions = async (
  api: THttpService,
  voucherNumber: string,
): Promise<TListPurchaseOptions> => {
  const path = `/act/miles/purchases/options?productCode=MILESPURCHASE&voucherNumber=${voucherNumber}`;
  try {
    const response = await api.get(path);
    const formatedResponse = formatSuccess(response.data);
    return formatedResponse;
  } catch (error) {
    throw new Error((error as { message: string }).message);
  }
};
